/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkspaceCampaignListItem
 */
export interface WorkspaceCampaignListItem {
    /**
     * The campaign's internal ID (unique)
     * @type {string}
     * @memberof WorkspaceCampaignListItem
     */
    workspaceCampaignId: string;
    /**
     * The campaign's custom external ID (unique)
     * @type {string}
     * @memberof WorkspaceCampaignListItem
     */
    externalCampaignId?: string;
    /**
     * Public message for the campaign
     * @type {string}
     * @memberof WorkspaceCampaignListItem
     */
    campaignMessage?: string;
}

export function WorkspaceCampaignListItemFromJSON(json: any): WorkspaceCampaignListItem {
    return WorkspaceCampaignListItemFromJSONTyped(json, false);
}

export function WorkspaceCampaignListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceCampaignListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'workspaceCampaignId': json['workspaceCampaignId'],
        'externalCampaignId': !exists(json, 'externalCampaignId') ? undefined : json['externalCampaignId'],
        'campaignMessage': !exists(json, 'campaignMessage') ? undefined : json['campaignMessage'],
    };
}

export function WorkspaceCampaignListItemToJSON(value?: WorkspaceCampaignListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'workspaceCampaignId': value.workspaceCampaignId,
        'externalCampaignId': value.externalCampaignId,
        'campaignMessage': value.campaignMessage,
    };
}

